exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-button-to-top {\n  position: fixed;\n  right: 1em;\n  bottom: 1em;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n}\n.uu5-bricks-button-to-top:hover {\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/button-to-top.less
// module id = 192
// module chunks = 0